import { useLocalization } from '@utils/useLocalization';
import { Box, Divider, Typography } from 'hephaestus/web';
import { EMPTY_RESULT_PLACEHOLDER } from '../calculator.constants';
import {
  formatCalculatorResultValue,
  getCalculatorLabel,
  isCalculatorFieldEnabled,
} from '../calculator.utils';

export const CalculatorResultRow = ({
  dividerBefore = false,
  emphasis = false,
  fieldKey,
  label,
  options,
  value,
}: {
  dividerBefore?: boolean;
  emphasis?: boolean;
  fieldKey: string;
  label: string;
  options: Record<string, unknown>;
  value?: string | number | null;
}) => {
  const { localizedDate } = useLocalization();

  if (!isCalculatorFieldEnabled(options[fieldKey])) return null;

  const rowLabel = getCalculatorLabel(options, fieldKey, label);
  const displayValue =
    value == null || value === ''
      ? EMPTY_RESULT_PLACEHOLDER
      : formatCalculatorResultValue(fieldKey, value, localizedDate);
  const rowVariant = emphasis ? 'bodyLarge' : 'bodyMedium';
  const fontWeight = emphasis ? 700 : 400;

  return (
    <>
      {dividerBefore && <Divider />}
      <Box
        data-testid={`calculator-result-row-${fieldKey}`}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Typography variant={rowVariant} sx={{ fontWeight }}>
          {rowLabel}
        </Typography>
        <Typography variant={rowVariant} sx={{ fontWeight }}>
          {displayValue}
        </Typography>
      </Box>
    </>
  );
};
